import styled from 'styled-components';

import { theme } from '../../../../common/ui/theme';

export const OfferAccordionContentWrapper = styled.div`
    width: calc(100% - 16px);
    margin: auto;
    border-bottom-left-radius: 1px;
    border-bottom-right-radius: 1px;
    border: 1px solid;
    border-color: ${theme.colors.border.muted};
    border-top: none;
    z-index: ${theme.zIndex[100]};
    position: relative;
`;
